<eiq-card [style]="style" [clickable]="true" (clicked)="clicked.emit()">
  <div slot="content" class="card-form-selector__card">
    <div class="card-form-selector__card-icon">
      <ng-content select="[slot=icon]"></ng-content>
    </div>
    <div class="card-form-selector__card-content">
      <span class="card-form-selector__card-content-title fs__md fw__600">
        <ng-content select="[slot=title]"></ng-content>
      </span>
      <span class="card-form-selector__card-content-description fs__md fw__500">
        <ng-content select="[slot=description]"></ng-content>
      </span>
    </div>
  </div>
</eiq-card>
